<template>
  <d-list-group flush>
    <d-list-group-item class="p-3">
      <d-form @submit.prevent="save">
        <d-form-row>

          <!-- Nome -->
          <d-col md="8" class="form-group autocomplete">
            <label for="name">
              Cliente
              <span class="link" @click.prevent="addNewClient()">Adicionar novo cliente</span>
            </label>
            <autocomplete
              ref="autocomplete"
              placeholder="Cliente"
              :state="hasErrorFiled('customer_name')"
              :items="items"
              item-show="name"
              :on-input="onInput"
              :on-select="setQuotationCustomer"
              :on-show-text="showText"
            ></autocomplete>
            <d-form-invalid-feedback>Cliente é obrigatório</d-form-invalid-feedback>
          </d-col>

          <!-- Type -->
          <d-col md="2" class="form-group">
            <label>Produtos</label>
            <d-form-input
              type="text"
              id="feQuotation_type"
              placeholder="Produtos"
              v-model="model.quotation_type"
              @change="capitalizeField('quotation_type')"
            />
            <d-form-invalid-feedback>Tipo de orçamento é obrigatório</d-form-invalid-feedback>
          </d-col>

          <!-- Status -->
          <d-col md="2" class="form-group">
            <label>Status</label>
            <d-select v-model="model.status">
              <option :value="option.slug" v-for="(option, index) in statusOptions" :key="index">{{ option.name }}</option>
            </d-select>
          </d-col>

        </d-form-row>

        <d-form-row>
          <!-- Descrição -->
          <d-col md="10" class="form-group">
            <label for="feDescription">Descriminação e local</label>
            <d-form-input
              type="text"
              id="feDescription"
              placeholder="Breve descrição para identicação"
              v-model="model.description"
              @change="capitalizeField('description')"
            />
          </d-col>

          <!-- Valid at -->
          <d-col md="2" class="form-group">
            <label>Validade</label>
            <datepicker :model.sync="model.valid_at"/>
          </d-col>

        </d-form-row>

        <d-form-row>
          <!-- Comentários -->
          <d-col md="12" class="form-group">
            <label for="feComentarios">
              Comentários
              <span class="link" @click.prevent="capitalizeField('comment', true)">Formatar texto</span>
            </label>
            <d-checkbox v-model="autoCapitalize" class="float-right" ><small>Auto Formatar</small></d-checkbox>
            <textarea
              v-model="model.comment"
              name="feComentarios"
              rows="5"
              class="form-control"
              @change="autoCapitalizeField('comment')"
            ></textarea>
          </d-col>

        </d-form-row>

        <!-- Product Table -->
        <d-form-row class="mt-4 mb-4 table-overflow">
          <table class="table table-striped table-bordered" role="table">
            <thead class="bg-light" role="rowgroup">
              <tr role="row">
                <th role="columnheader" class="text-center">ID</th>
                <th role="columnheader">Descrição produto</th>
                <th role="columnheader" class="text-center">Unid.</th>
                <th role="columnheader" class="text-center">Qtd.</th>
                <th role="columnheader" class="text-right">Valor un.</th>
                <th role="columnheader" class="text-right">Total</th>
                <th role="columnheader" class="text-right"></th>
              </tr>
            </thead>
            <tbody role="rowgroup">
              <tr role="row" v-for="(item, navItemId) in model.rows" :key="navItemId">
                <td role="cell" class="td-1">
                  <span class="d-block mt-2 text-center">{{navItemId + 1}}</span>
                </td>
                <td role="cell" class="td-4">
                  <d-form-input
                    type="text"
                    placeholder="Descrição"
                    v-model="item.description"
                    required
                    @change="capitalizeProductRow(navItemId)"
                  />
                  <a href="#" class="open-modal mt-1 d-clock" @click="openSettingsBlinds(navItemId)">Persiana</a>
                </td>
                <td role="cell" class="td-2">
                  <d-select
                    v-model="item.unit_type"
                    :options="productUnits"
                    value-field="name"
                    text-field="name"
                    @change="changeStep(item)"
                  >
                  </d-select>
                </td>
                <td role="cell" class="td-2">
                  <input type="number" class="text-center form-control" :step="item.step" placeholder="Qtd." v-model="item.quantity" @change="setTotal(item)" required/>
                </td>
                <td role="cell" class="td-3">
                  <d-input-group prepend="R$">
                    <input-currency
                      model-index="value"
                      placeholder="Valor"
                      :model="item"
                      :on-change="setTotal"
                    ></input-currency>
                  </d-input-group>
                  <span v-if="item.blinds && item.blinds.area">Área: <strong>{{ item.blinds.area }} m²</strong></span>
                </td>
                <td role="cell" class="td-3">
                  <d-input-group prepend="R$">
                    <input-currency
                      model-index="total"
                      placeholder="Total"
                      :model="item"
                      :on-change="setUnitValor"
                    ></input-currency>
                  </d-input-group>
                </td>
                <td role="cell" class="td-1 buttons">
                  <i class="fas fa-plus text-success" @click="addRow()" v-if="navItemId+1 == model.rows.length"></i>
                  <i class="fas fa-minus text-danger" @click="removeRow(navItemId)" v-if="model.rows.length > 1"></i>
                </td>
              </tr>
            </tbody>
          </table>

        </d-form-row>

        <d-form-row class="justify-content-end">

          <!-- Subtotal -->
          <d-col md="7" lg="6" xl="2" cols="12" class="form-group">
            <label for="feSubtotal">Subtotal</label>
            <d-input-group prepend="R$">
              <input-currency
                model-index="subtotal"
                placeholder="Subotal"
                :model="model"
                :on-change="setUnitValor"
                readonly
              ></input-currency>
            </d-input-group>
          </d-col>

          <!-- Desconto -->
          <d-col md="7" lg="4" xl="2" cols="12" class="form-group mb-0">
            <label for="feDesconto">Desconto</label>
            <d-input-group class="mb-3 discount">
              <d-input-group-addon prepend>
                <select class="input-group-text form-control custom-select" v-model="model.discount_type" @change="setQuotationTotal()">
                  <option value="pct" selected>%</option>
                  <option value="value">R$</option>
                </select>
              </d-input-group-addon>
              <input-currency
                model-index="discount"
                placeholder="Desconto"
                hiddenGroup=""
                :model="model"
                :on-change="setQuotationTotal"
              ></input-currency>
            </d-input-group>
          </d-col>

          <!-- Total -->
          <d-col md="7" lg="4" xl="2" cols="12" class="form-group">
            <label for="feTotal">Total</label>
            <d-input-group prepend="R$" :class="['is-' + hasErrorFiled('total')]">
              <input-currency
                model-index="total"
                placeholder="Total"
                :state="hasErrorFiled('total')"
                :model="model"
                :on-change="setQuotationDiscount"
              ></input-currency>
              <d-form-invalid-feedback>Total é obrigatório</d-form-invalid-feedback>
            </d-input-group>
          </d-col>

        </d-form-row>

        <d-form-row class="justify-content-end">

          <!-- Prazo da Obra -->
          <d-col sm="4" md="6" xl="2" class="form-group">
            <label for="feInputPrazoDaObra">Prazo de Entrega</label>
            <d-form-input type="number" id="feInputPrazoDaObra" placeholder="Quantos dias" class="text-right" v-model="model.delivery_time"/>
          </d-col>

          <!-- Data Inicio -->
          <d-col sm="4" md="6" xl="2" class="form-group">
            <label for="feInputPrazoDaObra">Tempo de Instalação</label>
            <d-form-input type="number" id="feInputPrazoDaObra" placeholder="Quantos dias" class="text-right" v-model="model.duration_time"/>
          </d-col>

        </d-form-row>

        <d-form-row class="justify-content-end">

          <!-- Condição de pagamento -->
          <d-col md="6" lg="6" xl="2" cols="12" class="form-group">
            <label for="fePagto">Cond. pagamento</label>
            <d-select v-model="model.payment_id">
              <option :value="option.id" v-for="(option, index) in paymentTypeOptions" :key="index">{{ option.name }}</option>
            </d-select>
          </d-col>

          <!-- Quantidade de parcelas -->
          <d-col md="6" lg="6" xl="2" cols="12" class="form-group">
            <label for="fePagto">Parcelas</label>
            <d-form-input type="number" id="fePagto" class="text-right" min="1" v-model="model.parcel" @change="setPortionValue()"/>
          </d-col>

          <!-- Valor da parcela -->
          <d-col md="6" lg="6" xl="2" cols="12" class="form-group">
            <label for="feParcela">Valor da parcela</label>
            <d-input-group prepend="R$">
              <input-currency
                model-index="parcel_value"
                placeholder="R$ 0,00"
                :model="model"
                :on-change="setUnitValor"
              ></input-currency>
            </d-input-group>
          </d-col>

          <div class="w-100 d-none d-xl-block d-lg-none"></div>

          <!-- Condição de pagamento -->
          <d-col md="6" lg="6" xl="6" cols="12" class="form-group">
            <label for="fePagtoInfo">Forma de pagamento</label>
            <d-form-input type="text" id="fePagtoInfo" class="text-left" v-model="model.payment_info"/>
          </d-col>

        </d-form-row>

        <d-button type="submit" class="btn-accent">Salvar</d-button>

      </d-form>
    </d-list-group-item>
    <add-customer-modal/>
    <blinds-quotation-modal ref="blinds"/>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import MixinDate from '_common/mixins/Date';
import Datepicker from '_shared/Datepicker.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import InputCurrency from '_shared/InputCurrency.vue';
import AddCustomerModal from '_modules/quotation/components/modal/AddCustomerModal.vue';
import QuotationService from '_services/rest/modules/quotation';
import MixinValidateForm from '_common/mixins/ValidateForm';
import MixinQuotationCalc from '_common/mixins/QuotationCalc';
import BlindsQuotationModal from '_modules/quotation/components/modal/BlindsQuotationModal.vue';
import MixinQuotationBlindsCalc from '_common/mixins/QuotationBlindsCalc';
import { _SALVE_CUSTOMER_SUCCESS_ } from '_modules/customer/components/CustomerModel';
import { capitalize, capitalizePhrase, firstLetterUppercase, getDateTimeISO } from '_utils';
import {
  ROW,
  MODEL,
  TYPE_OPTIONS,
  STATUS_OPTIONS,
  PAYMENT_TYPE_OPTIONS,
  PRODUCT_UNITS_OPTIONS,
  _LOAD_MODEL_,
  _FINISHED_SAVE_REQUEST_,
  _UPDATE_QUOTATION_ROWS_,
  _OPEN_MODAL_,
} from './QuotationModel';

export default {
  name: 'quotation-form',
  mixins: [MixinQuotationCalc, MixinValidateForm, MixinDate, MixinQuotationBlindsCalc],
  components: {
    Datepicker,
    Autocomplete,
    InputCurrency,
    AddCustomerModal,
    BlindsQuotationModal,
  },
  data() {
    return {
      model: { ...MODEL },
      items: [],
      loading: false,
      statusOptions: STATUS_OPTIONS,
      autoCapitalize: true,
      selectedRowIndex: 0,
      errors: {
        customer_name: { required: false },
        quotation_type: { required: false },
        total: { required: false },
      },
    };
  },
  computed: {
    custumers() {
      return this.$store.state.customer.customerList.list || [];
    },
    paymentTypeOptions() {
      const { paymentTypeOptions } = this.$store.state.quotation;
      if (paymentTypeOptions && paymentTypeOptions.length) {
        return paymentTypeOptions;
      }
      return PAYMENT_TYPE_OPTIONS;
    },
    productUnits() {
      const { productUnits } = this.$store.state.quotation;
      if (productUnits && productUnits.length) {
        return productUnits;
      }
      return PRODUCT_UNITS_OPTIONS;
    },
    typeOptions() {
      const { typeOptions } = this.$store.state.quotation;
      if (typeOptions && typeOptions.length) {
        return typeOptions;
      }
      return TYPE_OPTIONS;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getTypeOptions',
      'getProductUnits',
      'getPaymentTypeOptions',
      'getCustomerList',
    ]),
    addRow() {
      this.model.rows.push({ ...ROW });
      setTimeout(() => {
        this.calcSubtotal();
      }, 50);
    },
    addNewClient() {
      this.setToggle({ type: 'add_customer_modal', bool: true });
    },
    autoCapitalizeField(field) {
      if (this.autoCapitalize) {
        this.model[field] = capitalize(this.model[field]);
      }
    },
    capitalizeComment() {
      this.model.comment = firstLetterUppercase(this.model.comment);
    },
    capitalizeField(field, phrase = false) {
      if (phrase) {
        this.model[field] = capitalizePhrase(this.model[field]);
        return true;
      }
      this.model[field] = capitalize(this.model[field]);
      return true;
    },
    capitalizeProductRow(index) {
      this.model.rows[index].description = capitalize(this.model.rows[index].description);
    },
    cleanEmptyRows() {
      this.model.rows = this.model.rows.filter(row => row.description);
    },
    changeStep(item) {
      item.step = 1;
      setTimeout(() => {
        if (item.unit_type === 'm²') {
          item.step = 0.01;
          return item;
        }
        return item;
      }, 50);
    },
    formatDate() {
      this.model.started_date = getDateTimeISO(this.model.started_date);
      this.model.delivery_date = getDateTimeISO(this.model.delivery_date);
    },
    getListCustomer(name = '') {
      this.toggleLoading();
      const params = {
        skip: 0,
        take: 10,
        search: name,
      };
      this.getCustomerList(params)
        .then(() => {
          this.toggleLoading();
          this.items = this.custumers;
        });
    },
    getOptions() {
      if (!this.$store.state.quotation.typeOptions) {
        this.setToggle({ type: 'progress', bool: true });
        this.getTypeOptions()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
      if (!this.$store.state.quotation.paymentTypeOptions) {
        this.setToggle({ type: 'progress', bool: true });
        this.getPaymentTypeOptions()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
      if (!this.$store.state.quotation.productUnits) {
        this.setToggle({ type: 'progress', bool: true });
        this.getProductUnits()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
    },
    onInput(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getListCustomer(name);
      }, 500);
    },
    openSettingsBlinds(index) {
      this.selectedRowIndex = index;
      Events.$emit(_OPEN_MODAL_, { quotation: this.model.rows[index], type: 'blinds_quotation_modal' });
      this.setToggle({ type: 'blinds_quotation_modal', bool: true });
    },
    removeRow(index) {
      this.model.rows.splice(index, 1);
      setTimeout(() => {
        this.calcSubtotal();
      }, 50);
    },
    save() {
      if (this.checkForm()) {
        this.cleanEmptyRows();
        this.formatDate();
        this.toggleLoading();
        this.model.valid_at = getDateTimeISO(this.model.valid_at);
        QuotationService.save(this.model)
          .then(response => this.success(response))
          .catch(error => {
            this.toggleLoading();
            this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
          });
      }
      return null;
    },
    setClient(customer) {
      if (this.$refs.autocomplete) {
        this.$refs.autocomplete.$refs.input.value = customer.name;
      }
    },
    setQuotationCustomer(customer) {
      this.model.customer = customer;
      this.model.customer_id = customer.id;
      this.model.customer_name = customer.name;
    },
    showText(item) {
      return `${item.name} <strong class="document">${item.document}</strong>`;
    },
    success(quotation) {
      this.toggleLoading();
      this.activeAlert({ message: 'Orçamento salvo com sucesso', theme: 'success' });
      Events.$emit(_FINISHED_SAVE_REQUEST_, quotation);
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = { ...newValue };
      this.setClient(newValue.customer);
    });
    Events.$on(_SALVE_CUSTOMER_SUCCESS_, customer => {
      this.setToggle({ type: 'add_customer_modal', bool: false });
      this.setClient(customer);
      this.setQuotationCustomer(customer);
    });
    Events.$on(_FINISHED_SAVE_REQUEST_, quotation => {
      this.$router.push(`/admin/orcamentos/${quotation.id}`);
    });
    Events.$on(_UPDATE_QUOTATION_ROWS_, row => {
      this.$set(this.model.rows, this.selectedRowIndex, row);
      setTimeout(() => {
        this.calcSubtotal(this.model.rows[this.selectedRowIndex]);
      }, 50);
    });
    this.getOptions();
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.td {
  &-1 {
    width: 4%;
  }
  &-2 {
    width: 10%;
    min-width: 75px;
  }
  &-3 {
    width: 15%;
  }
  &-4 {
    width: 44%;
    min-width: 300px;
  }
}
.buttons {
  text-align: center;
  vertical-align: middle;
  .btn-sm { padding: 0.4rem 0.7rem; }
  i { cursor: pointer; }
}
.link {
  cursor: pointer;
  color: $primary;
  font-size: 0.7rem;
  margin-left: 10px;
  &:hover {
    text-decoration: underline;
  }
}
@media only screen
  and (max-width: 760px), (min-device-width: 768px)
  and (max-device-width: 1024px)  {

  /* Force table to not be like tables anymore */
  table, thead, tbody, th, td, tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr {
    margin: 0;
    &:nth-child(odd) {
      background: #ccc;
    }
  }

  td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    vertical-align: middle;
    padding-top: 30px;
    &:first-child {
      text-align: center;
      padding: 3px 3px 9px 3px;
      &:before {
        position: absolute;
        top: 10px;
        left: 116px;
        width: 5%;
        padding-right: 10px;
        white-space: nowrap;
      }
    }
    &:before {
      /* Now like a table header */
      position: absolute;
      /* Top/left values mimic padding */
      top: 5px;
      left: 6px;
      width: 5%;
      padding-right: 10px;
      white-space: nowrap;
    }
    &.td-1,
    &.td-2,
    &.td-3,
    &.td-4 {
      width: 100%;
    }
    &.buttons {
      i {
        padding: 10px;
        color: #fff !important;
        border-radius: 5px;
        &.fa-minus{
          border: 1px solid #c4183c;
          background: #dc3545;
        }
        &.fa-plus {
          margin-right: 5px;
          border: 1px solid #28a745;
          background: #17c671;
        }

      }
    }
  }

  /*
  Label the data
  You could also use a data-* attribute and content for this. That way "bloats" the HTML, this way means you need to keep HTML and CSS in sync. Lea Verou has a clever way to handle with text-shadow.
  */
  td:nth-of-type(1):before { content: "ID"; }
  td:nth-of-type(2):before { content: "Descrição produto"; }
  td:nth-of-type(3):before { content: "Unid."; }
  td:nth-of-type(4):before { content: "Qtd."; }
  td:nth-of-type(5):before { content: "Valor un."; }
  td:nth-of-type(6):before { content: "Total"; }
  td:nth-of-type(7):before { content: "Op\00e7\00f5""es"; }
}

</style>
<style lang="scss">
@import '~_scss/overrides';

.input-group.is-invalid {
  .input-group-prepend {
    .input-group-text {
      color: $red;
      border-color: $red;
    }
  }
}

.document {
  margin-left: 10px;
  font-weight: bold;
}
</style>
